import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Disc3, Crown, Moon, Sun } from 'lucide-react';
export function AboutSection() {
  const features = [{
    icon: Disc3,
    title: 'Live DJ Nights',
    description: 'Every Friday & Saturday featuring top DJs spinning the hottest tracks while you enjoy premium bottle service.',
    detail: 'Fridays & Saturdays • 11PM-3AM'
  }, {
    icon: Crown,
    title: 'VIP Experiences',
    description: 'Exclusive access to our premium spaces with dedicated staff, custom menus, and bottle service packages.',
    detail: null
  }, {
    icon: Moon,
    title: 'After Hours',
    description: 'The hidden gem for industry insiders and night owls. Curated playlists, craft mocktails, and immersive experiences.',
    detail: null
  }, {
    icon: Sun,
    title: 'Daytime',
    description: 'Gourmet dining, sports viewing, and premium hookah in a sophisticated atmosphere.',
    detail: 'Premium Cocktails • Gourmet Dining • Premium Hookah'
  }];
  return <section id="about" className="py-24 bg-[#0B1014] relative overflow-hidden" data-id="element-28">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-5" data-id="element-29">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#DDA247] rounded-full blur-3xl" data-id="element-30" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#DDA247] rounded-full blur-3xl" data-id="element-31" />
      </div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-32">
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-33">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-34">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 tracking-wide" data-id="element-35">
              ABOUT US
            </h2>
            <div className="w-24 h-1 bg-[#DDA247] mx-auto mb-8" data-id="element-36" />
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-37">
              House of Flavors in Laurel, Maryland brings bold flavors, premium
              hookah, and electrifying music together in one unforgettable
              experience. We offer a lively atmosphere with handcrafted drinks,
              and live entertainment, perfect for relaxing, celebrating, or
              turning any night into a memorable event.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-16" data-id="element-38">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.6
        }} className="text-center group" data-id="element-39">
              <div className="inline-flex items-center justify-center w-16 h-16 mb-4 bg-[#DDA247]/10 rounded-full group-hover:bg-[#DDA247]/20 transition-colors duration-300" data-id="element-40">
                <feature.icon className="w-8 h-8 text-[#DDA247]" data-id="element-41" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2 tracking-wide" data-id="element-42">
                {feature.title}
              </h3>
              <p className="text-gray-400 text-sm mb-3" data-id="element-43">
                {feature.description}
              </p>
              {feature.detail && <p className="text-[#DDA247] text-xs font-medium tracking-widest uppercase" data-id="element-44">
                  {feature.detail}
                </p>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}